module.exports = __webpack_public_path__ + "img/introduce_icon2.b40c4ad5.png";